import React from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Button,
  Form,
  Input,
  FormFeedback,
  ButtonGroup,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useSelector, useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { editIncoterm, updateIncoterm } from "../../../store/actions"

import { useEffect, useState } from "react"

const EditIncoterm = props => {
  const dispatch = useDispatch()
  document.title = "Edit Incoterm"
  const { id } = useParams()

  const [details, setDetails] = useState({})

  useEffect(() => {
    dispatch(editIncoterm(id))
  }, [dispatch])

  const incoterm = useSelector(state => state.incotermCity)

  useEffect(() => {
    let inco = []
    if (incoterm && incoterm.incotermCity && incoterm.incotermCity.length > 0) {
      inco = incoterm.incotermCity.filter(
        incotermCity => incotermCity.incoterm_city_id == id
      )
    }
    if (inco.length > 0) {
      setDetails(inco[0])
    } else {
      props.history.push("/dropdown/incoterm_city/list")
    }
  }, [])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      incoterm_city_id:
        details && details.incoterm_city_id ? details.incoterm_city_id : "",

      incoterm_city:
        details && details.incoterm_city ? details.incoterm_city : "",

      is_default: details && details.is_default ? 1 : 0,
    },
    validationSchema: Yup.object({
      incoterm_city: Yup.string().required("Please enter incoterm city"),
    }),
    onSubmit: values => {
      values.incoterm_city_id = id // incoterm_city_id is from api thats why this needs to be same with "id"
      dispatch(updateIncoterm(values, props.history))
    },
  })

  const { error } = useSelector(state => ({
    error: state.incotermCity.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Edit Incoterm City" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="editIncotermForm"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3 mt-1">
                          <Label htmlFor="inco">Incoterm City</Label>
                          <Input
                            name="incoterm_city"
                            type="text"
                            id="inco"
                            placeholder="Enter incoterm city"
                            autoComplete="off"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.incoterm_city || ""}
                          />
                          {validation.touched.incoterm_city &&
                          validation.errors.incoterm_city ? (
                            <FormFeedback type="invalid">
                              {validation.errors.incoterm_city}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      <h6>Default : </h6>
                      <ButtonGroup>
                        <Button
                          name="is_default"
                          color="success"
                          outline
                          value={1}
                          active={validation.values.is_default == 1}
                          onClick={validation.handleChange}
                        >
                          Yes
                        </Button>

                        <Button
                          name="is_default"
                          color="secondary"
                          outline
                          value={0}
                          active={validation.values.is_default == 0}
                          onClick={validation.handleChange}
                        >
                          No
                        </Button>
                      </ButtonGroup>
                    </div>
                    <br />
                    <div>
                      {incoterm && incoterm.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Updating ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Update
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default EditIncoterm
